
<div class="checkout-holder">
  <div class="checkout-content">
    <ng-content></ng-content>
  </div>
</div>